;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('SpecialShapesService', specialShapesService)

  /* @ngInject */
  function specialShapesService ($q) {
    var aSpecialShapes = [
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-122.png',
        filePath: '/assets/shapes/specialShapes/special-122.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-121.png',
        filePath: '/assets/shapes/specialShapes/special-121.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-120.png',
        filePath: '/assets/shapes/specialShapes/special-120.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-119.png',
        filePath: '/assets/shapes/specialShapes/special-119.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-118.png',
        filePath: '/assets/shapes/specialShapes/special-118.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-117.png',
        filePath: '/assets/shapes/specialShapes/special-117.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-116.png',
        filePath: '/assets/shapes/specialShapes/special-116.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-73.png',
        filePath: '/assets/shapes/specialShapes/special-73.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-72.png',
        filePath: '/assets/shapes/specialShapes/special-72.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-71.png',
        filePath: '/assets/shapes/specialShapes/special-71.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-70.png',
        filePath: '/assets/shapes/specialShapes/special-70.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-69.png',
        filePath: '/assets/shapes/specialShapes/special-69.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-68.png',
        filePath: '/assets/shapes/specialShapes/special-68.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-67.png',
        filePath: '/assets/shapes/specialShapes/special-67.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-66.png',
        filePath: '/assets/shapes/specialShapes/special-66.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-65.png',
        filePath: '/assets/shapes/specialShapes/special-65.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-64.png',
        filePath: '/assets/shapes/specialShapes/special-64.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-63.png',
        filePath: '/assets/shapes/specialShapes/special-63.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-62.png',
        filePath: '/assets/shapes/specialShapes/special-62.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-61.png',
        filePath: '/assets/shapes/specialShapes/special-61.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-60.png',
        filePath: '/assets/shapes/specialShapes/special-60.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-59.png',
        filePath: '/assets/shapes/specialShapes/special-59.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-58.png',
        filePath: '/assets/shapes/specialShapes/special-58.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-57.png',
        filePath: '/assets/shapes/specialShapes/special-57.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-56.png',
        filePath: '/assets/shapes/specialShapes/special-56.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-55.png',
        filePath: '/assets/shapes/specialShapes/special-55.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-54.png',
        filePath: '/assets/shapes/specialShapes/special-54.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-53.png',
        filePath: '/assets/shapes/specialShapes/special-53.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-52.png',
        filePath: '/assets/shapes/specialShapes/special-52.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-51.png',
        filePath: '/assets/shapes/specialShapes/special-51.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-50.png',
        filePath: '/assets/shapes/specialShapes/special-50.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-49.png',
        filePath: '/assets/shapes/specialShapes/special-49.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-48.png',
        filePath: '/assets/shapes/specialShapes/special-48.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-47.png',
        filePath: '/assets/shapes/specialShapes/special-47.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-46.png',
        filePath: '/assets/shapes/specialShapes/special-46.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-45.png',
        filePath: '/assets/shapes/specialShapes/special-45.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-45.png',
        filePath: '/assets/shapes/specialShapes/special-45.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-44.png',
        filePath: '/assets/shapes/specialShapes/special-44.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-43.png',
        filePath: '/assets/shapes/specialShapes/special-43.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-42.png',
        filePath: '/assets/shapes/specialShapes/special-42.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-41.png',
        filePath: '/assets/shapes/specialShapes/special-41.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-40.png',
        filePath: '/assets/shapes/specialShapes/special-40.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-39.png',
        filePath: '/assets/shapes/specialShapes/special-39.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-38.png',
        filePath: '/assets/shapes/specialShapes/special-38.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-37.png',
        filePath: '/assets/shapes/specialShapes/special-37.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-36.png',
        filePath: '/assets/shapes/specialShapes/special-36.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-35.png',
        filePath: '/assets/shapes/specialShapes/special-35.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-34.png',
        filePath: '/assets/shapes/specialShapes/special-34.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-33.png',
        filePath: '/assets/shapes/specialShapes/special-33.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-32.png',
        filePath: '/assets/shapes/specialShapes/special-32.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-31.png',
        filePath: '/assets/shapes/specialShapes/special-31.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-29.png',
        filePath: '/assets/shapes/specialShapes/special-29.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-28.png',
        filePath: '/assets/shapes/specialShapes/special-28.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-27.png',
        filePath: '/assets/shapes/specialShapes/special-27.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-26.png',
        filePath: '/assets/shapes/specialShapes/special-26.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-25.png',
        filePath: '/assets/shapes/specialShapes/special-25.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-24.png',
        filePath: '/assets/shapes/specialShapes/special-24.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-23.png',
        filePath: '/assets/shapes/specialShapes/special-23.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-22.png',
        filePath: '/assets/shapes/specialShapes/special-22.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-21.png',
        filePath: '/assets/shapes/specialShapes/special-21.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-20.png',
        filePath: '/assets/shapes/specialShapes/special-20.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-19.png',
        filePath: '/assets/shapes/specialShapes/special-19.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-18.png',
        filePath: '/assets/shapes/specialShapes/special-18.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-17.png',
        filePath: '/assets/shapes/specialShapes/special-17.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-16.png',
        filePath: '/assets/shapes/specialShapes/special-16.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-15.png',
        filePath: '/assets/shapes/specialShapes/special-15.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-14.png',
        filePath: '/assets/shapes/specialShapes/special-14.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-13.png',
        filePath: '/assets/shapes/specialShapes/special-13.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-12.png',
        filePath: '/assets/shapes/specialShapes/special-12.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-10.png',
        filePath: '/assets/shapes/specialShapes/special-10.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-9.png',
        filePath: '/assets/shapes/specialShapes/special-9.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-8.png',
        filePath: '/assets/shapes/specialShapes/special-8.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-7.png',
        filePath: '/assets/shapes/specialShapes/special-7.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-115.png',
        filePath: '/assets/shapes/specialShapes/special-115.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-114.png',
        filePath: '/assets/shapes/specialShapes/special-114.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-113.png',
        filePath: '/assets/shapes/specialShapes/special-113.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-112.png',
        filePath: '/assets/shapes/specialShapes/special-112.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-111.png',
        filePath: '/assets/shapes/specialShapes/special-111.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-109.png',
        filePath: '/assets/shapes/specialShapes/special-109.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-107.png',
        filePath: '/assets/shapes/specialShapes/special-107.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-106.png',
        filePath: '/assets/shapes/specialShapes/special-106.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-105.png',
        filePath: '/assets/shapes/specialShapes/special-105.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-104.png',
        filePath: '/assets/shapes/specialShapes/special-104.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-103.png',
        filePath: '/assets/shapes/specialShapes/special-103.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-101.png',
        filePath: '/assets/shapes/specialShapes/special-101.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-100.png',
        filePath: '/assets/shapes/specialShapes/special-100.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-99.png',
        filePath: '/assets/shapes/specialShapes/special-99.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-98.png',
        filePath: '/assets/shapes/specialShapes/special-98.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-97.png',
        filePath: '/assets/shapes/specialShapes/special-97.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-96.png',
        filePath: '/assets/shapes/specialShapes/special-96.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-95.png',
        filePath: '/assets/shapes/specialShapes/special-95.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-94.png',
        filePath: '/assets/shapes/specialShapes/special-94.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-93.png',
        filePath: '/assets/shapes/specialShapes/special-93.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-92.png',
        filePath: '/assets/shapes/specialShapes/special-92.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-91.png',
        filePath: '/assets/shapes/specialShapes/special-91.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-90.png',
        filePath: '/assets/shapes/specialShapes/special-90.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-89.png',
        filePath: '/assets/shapes/specialShapes/special-89.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-88.png',
        filePath: '/assets/shapes/specialShapes/special-88.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-87.png',
        filePath: '/assets/shapes/specialShapes/special-87.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-86.png',
        filePath: '/assets/shapes/specialShapes/special-86.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-85.png',
        filePath: '/assets/shapes/specialShapes/special-85.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-84.png',
        filePath: '/assets/shapes/specialShapes/special-84.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-83.png',
        filePath: '/assets/shapes/specialShapes/special-83.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-82.png',
        filePath: '/assets/shapes/specialShapes/special-82.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-81.png',
        filePath: '/assets/shapes/specialShapes/special-81.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-80.png',
        filePath: '/assets/shapes/specialShapes/special-80.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-79.png',
        filePath: '/assets/shapes/specialShapes/special-79.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-78.png',
        filePath: '/assets/shapes/specialShapes/special-78.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-77.png',
        filePath: '/assets/shapes/specialShapes/special-77.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-76.png',
        filePath: '/assets/shapes/specialShapes/special-76.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-75.png',
        filePath: '/assets/shapes/specialShapes/special-75.svg'
      },
      {
        name: '',
        imgSrc: '/assets/img/components/elements/specialShapes/special-74.png',
        filePath: '/assets/shapes/specialShapes/special-74.svg'
      },
      {
        name: 'circulo vazado',
        imgSrc: '/assets/img/components/elements/specialShapes/special-2.png',
        filePath: '/assets/shapes/specialShapes/special-2.svg',
        width: 120
      },
      {
        name: 'circulo vazado',
        imgSrc: '/assets/img/components/elements/specialShapes/special-3.png',
        filePath: '/assets/shapes/specialShapes/special-3.svg',
        width: 120
      },
      {
        name: 'circulo',
        imgSrc: '/assets/img/components/elements/specialShapes/special-4.png',
        filePath: '/assets/shapes/specialShapes/special-4.svg',
        width: 120
      },
      {
        name: 'background',
        imgSrc: '/assets/img/components/elements/specialShapes/special-5.png',
        filePath: '/assets/shapes/specialShapes/special-5.svg',
        width: 120
      },
      {
        name: 'retangulo',
        imgSrc: '/assets/img/components/elements/specialShapes/special-6.png',
        filePath: '/assets/shapes/specialShapes/special-6.svg',
        width: 120
      }
    ]

    var service = {
      aSpecialShapes: aSpecialShapes,
      fnSetSpecialShapes: fnSetSpecialShapes,
      fnGetSpecialShapes: fnGetSpecialShapes,
      fnGetSpecialShapesPromise: fnGetSpecialShapesPromise
    }
    return service

    // For now we are using an static array of shapes
    // in the future it will come from the backend
    function fnGetSpecialShapes () {
      return aSpecialShapes
    }

    function fnSetSpecialShapes (aShapes) {
      aSpecialShapes = aShapes
    }

    function fnGetSpecialShapesPromise () {
      // from now we are returning static data
      // in the future we should get the data from server
      // and return a Promise
      return $q.resolve(aSpecialShapes)
    }
  }
})()
